import { addGTMEvent } from 'api/googleTagManager'

export function now() {
  return window.performance ? window.performance.now() : Date.now()
}

interface UserTimingEvent {
  eventCategory: string;
  label: string;
  value: number;
  variable: string;
}

/**
 * Used to track performance events.
 * Ex.: Time to load JS, time for a component to appear.
 */
export function reportUserTimingEvent(event: UserTimingEvent) {
  addGTMEvent({
    event: 'ua-timing-event',
    eventVariable: event.variable,
    eventCategory: event.eventCategory,
    eventValue: event.value,
    eventLabel: event.label,
  })
}
